import { Card } from "primereact/card";
import { Divider } from "primereact/divider";
import React from "react";
import { useRouteError } from "react-router-dom";
import { verifyHostName } from "../../utils/utils";
import { webAppEnvUrls } from "../../enums/WebAppEnvUrls";
import { Button } from "primereact/button";
import { Messages } from "../../enums/Messages";
import { ButtonLabels } from "../../enums/ButtonLabels";

interface IGlobalErrorFallbackProps {
  error?: unknown;
}

const GlobalErrorFallback: React.FC<IGlobalErrorFallbackProps> = (props) => {
  // Prefer error from props (ErrorBoundary), fallback to useRouteError (React Router)
  const routeError = useRouteError();
  const error = props.error ?? routeError;
  // show error details if the environment is non-production
  const showErrorMessage = !verifyHostName(webAppEnvUrls.prod);

  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div className="flex justify-content-center align-items-center h-screen p-4">
      <Card className="shadow-4 w-full md:w-6 lg:w-4 text-center">
        <div className="mb-3">
          <i className="pi pi-exclamation-triangle text-4xl text-red-500" />
        </div>
        <h2 className="text-2xl font-bold text-900 mb-2">
          {Messages.SOMETHING_WENT_WRONG}
        </h2>
        <p className="text-600 mb-3">
          We encountered an unexpected error.{" "}
          <Button
            className="p-0"
            onClick={handleReload}
            link
            label={ButtonLabels.CLICK_HERE_TO_RELOAD}
          />{" "}
          or Contact support if you see this error again.
        </p>
        {showErrorMessage && (
          <pre className="text-sm text-red-400 font-medium">
            {error instanceof Error
              ? error.message
              : ((error as { statusText?: string; message?: string })
                  ?.statusText ??
                (error as { statusText?: string; message?: string })?.message ??
                Messages.UNEXPECTED_ERROR)}
          </pre>
        )}
        <Divider />
      </Card>
    </div>
  );
};

export default GlobalErrorFallback;
